var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.attemptOptions,"label":_vm.$t('attemptsNoResponse'),"value":_vm.value,"outlined":"","data-testid":"attemptsVoiceAttemptsSelect"},on:{"change":function($event){return _vm.onChange($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }